export default __webpack_public_path__ + "static/sm-poster11-c03a8be1083561946e06a03fc662321f.png";